export default "__VITE_ASSET__JazIeA1K__"